module.exports = __webpack_public_path__ + "img/menu.76774e5e.svg";